import { Expose, Transform, Type } from 'class-transformer';
import {
  IsArray,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { TagType } from '@coworkrz/cards/types';
import { CastHelper } from './cast.helper';
import { ProductUnit } from '@coworkrz/products/types';
import { BaseDto } from './base.dto';
import { CategoryDto } from './categories.dto';
import { SharedPriceDto } from './shared.dto';
import { ReservationDto } from './reservations.dto';

export class CreateProductDto {
  @IsNotEmpty()
  name!: string;

  @IsOptional()
  @IsNotEmpty()
  code!: string;

  @IsUUID()
  category!: string;
}

export class ProductPreviewDto extends BaseDto {
  @Expose()
  name: string;

  @Expose()
  code: string;

  @Expose()
  description: string;

  @Expose()
  image: string;

  @Expose()
  externalRef: number | string;

  @Expose()
  @Type(() => CategoryDto)
  category: CategoryDto;

  @Expose()
  @Type(() => SharedPriceDto)
  prices: SharedPriceDto[];
}

export class ProductDto extends ProductPreviewDto {
  @Expose()
  @Type(() => ReservationDto)
  reservations: ReservationDto[];
}

export class ProductFilters {
  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value, { default: false }))
  active?: boolean;

  @IsOptional()
  @IsString()
  category?: string;

  @IsOptional()
  @IsString()
  query?: string;

  @IsOptional()
  @IsArray()
  ids?: string[];

  @IsOptional()
  @Transform(({ value }) => CastHelper.trim(value))
  @IsEnum(TagType)
  priceTag?: TagType;

  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  strictOnPriceTag?: boolean;

  @IsOptional()
  @Transform(({ value }) => CastHelper.toBoolean(value))
  subscriptionPricesOnly?: boolean;

  @IsOptional()
  @IsArray()
  @IsEnum(ProductUnit, { each: true })
  @Transform(({ value }) => CastHelper.toArray<ProductUnit>(value))
  priceUnits?: ProductUnit[];
}
